import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMember } from "../features/auth/useMember";
import { AppShell } from "./AppShell";

export function ProtectedLayout() {
  const state = useMember();
  const location = useLocation();

  if (state.status === "loading") {
    return (
      <div className="pw-centered-page">
        <p style={{ color: "var(--pw-color-text-muted)" }}>Lädt …</p>
      </div>
    );
  }
  if (state.status === "signed-out") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return (
    <AppShell member={state.member}>
      <Outlet context={state} />
    </AppShell>
  );
}
